import { useNotificationStore } from 'Modules/notification/store';
import {
  getHttpErrorStatus,
  shouldTreatFetchFailureAsNetwork,
} from 'Modules/videoHistory/utils/isNetworkTransportError';

type ResolveFetchErrorOptions = {
  suppressErrorToast: boolean;
  toastTitle: string;
  toastMessage: string;
};

export const resolveFetchError = <TNetworkSentinel extends string>(
  error: unknown,
  networkSentinel: TNetworkSentinel,
  { suppressErrorToast, toastTitle, toastMessage }: ResolveFetchErrorOptions
): null | TNetworkSentinel => {
  if (getHttpErrorStatus(error) === 404) {
    return null;
  }

  if (shouldTreatFetchFailureAsNetwork(error)) {
    return networkSentinel;
  }

  if (!suppressErrorToast) {
    useNotificationStore.getState().addNotify({
      type: 'error',
      dismissible: true,
      title: toastTitle,
      message: toastMessage,
    });
  }

  return null;
};